import React, { useRef } from 'react'
import { GoogleAuthProvider } from 'firebase/auth';
import GoogleLogin from './GoogleLogin';
import logo from "../assets/logo.svg";
const Signup = () => {


  return (
    <div className="flex flex-col w-full h-full justify-center items-center mt-44">
      <img
              src={logo}
              alt="..."
              class="lg:inline-block object-scale-down h-32 w-32 mt-4"
            />
      <GoogleLogin/>
    </div>
  )
}

export default Signup;
